import React from 'react';
import { Step, StepButton, StepLabel, Stepper, Typography } from '@mui/material';
import { STEP_CONFIG } from '../../constants';
import { getStepIndex, isStepUnlocked } from '../../lib';
import { DealBuilderStep } from '../../types';
import { lightGreen } from '@mui/material/colors';

interface Props {
  viewStep: DealBuilderStep;
  progressStep: DealBuilderStep;
  completedSteps: Set<DealBuilderStep>;
  onStepClick: (step: DealBuilderStep) => void;
}

export const DealBuilderStepper = ({ viewStep, progressStep, completedSteps, onStepClick }: Props) => {
  const viewIndex = getStepIndex(viewStep);

  return (
    <Stepper
      nonLinear
      activeStep={viewIndex}
      sx={{
        '& .MuiStepIcon-root.Mui-completed': { color: lightGreen[400] },
        '& .MuiStepConnector-lineHorizontal': { borderTopWidth: 2.5 },
        '& .Mui-completed .MuiStepConnector-line': { borderColor: lightGreen[400] },
        // Also colors the connector leading into the currently active step
        '& .Mui-active .MuiStepConnector-line': { borderColor: lightGreen[400] },
        '& .MuiStepLabel-label': { textAlign: 'right' },
      }}
    >
      {STEP_CONFIG.map(({ step, label, subLabel }) => (
        <Step key={step} completed={step !== viewStep && (getStepIndex(step) < viewIndex || completedSteps.has(step))}>
          <StepButton disabled={!isStepUnlocked(step, progressStep)} onClick={() => onStepClick(step)}>
            <StepLabel>
              {label}
              {subLabel && (
                <Typography variant="caption" component="div" color="text.secondary">
                  {subLabel}
                </Typography>
              )}
            </StepLabel>
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
};
